import { SearchOutlined } from "@ant-design/icons";
import { Col, DatePicker, Form, Input, Row } from "antd";
import { cotizacionesStartLoad } from "../../../actions/cotizacion";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import {
  DateFormats,
  FiltersSearch_Types,
} from "../../../types/typesConstants";
import { parseDateFormatBackEnd } from "../../../helpers";
import { FilterBtn, SelectUi, FormUi } from "../../ui";

const initialValues = {
  tipofiltro: FiltersSearch_Types.FECHAEMISION,
  cliente: null,
  fechaemision: [dayjs(), dayjs()],
};
const optionsSearch = [
  {
    value: FiltersSearch_Types.CLIENTE,
    label: "CLIENTE",
  },
  {
    value: FiltersSearch_Types.FECHAEMISION,
    label: "FECHA EMISIÓN",
  },
];
export const CotizacionSearchList = () => {
  const [form] = Form.useForm();
  const tipofiltro = Form.useWatch("tipofiltro", form);
  const dispatch = useDispatch();
  const handleSubmit = (values) => {
    let query_search = {};
    if (tipofiltro === "CLIE") query_search = { search: values?.cliente };
    else {
      const fechaemision_after = parseDateFormatBackEnd(
        values?.fechaemision?.[0],
      );
      const fechaemision_before = parseDateFormatBackEnd(
        values?.fechaemision?.[1],
      );
      query_search = { fechaemision_after, fechaemision_before };
    }
    localStorage.setItem("SearhFormTable", JSON.stringify(query_search));

    dispatch(cotizacionesStartLoad(query_search));
  };
  return (
    <Row>
      <Col sm={32} md={32} xl={24}>
        <FormUi
          name="advanced_search"
          className="ant-advanced-search-form"
          initialValues={initialValues}
          handleSubmit={handleSubmit}
          form={form}
        >
          <Row>
            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
              <Form.Item name="tipofiltro" label="Filtrar por">
                <SelectUi data={optionsSearch} placeholder="Filtrar por" />
              </Form.Item>
            </Col>
            {tipofiltro === FiltersSearch_Types.CLIENTE && (
              <Col xs={12} sm={12} md={8} lg={4} xl={4} offset={1}>
                <Form.Item name="cliente">
                  <Input
                    name="cliente"
                    placeholder="Ingrese nombre de cliente"
                    allowClear
                    addonAfter={<SearchOutlined />}
                  />
                </Form.Item>
              </Col>
            )}
            {tipofiltro === FiltersSearch_Types.FECHAEMISION && (
              <Col xs={12} sm={12} md={8} lg={4} xl={4} offset={1}>
                <Form.Item
                  name="fechaemision"
                  rules={[
                    {
                      required: tipofiltro === "FEMI" ? true : false,
                      message: "La Fecha de emisión es obligatorio",
                    },
                  ]}
                >
                  <DatePicker.RangePicker format={DateFormats.frontend} />
                </Form.Item>
              </Col>
            )}
            <Col xs={12} sm={12} md={8} lg={4} xl={4} offset={1}>
              <FilterBtn htmlType="submit" />
            </Col>
          </Row>
        </FormUi>
      </Col>
    </Row>
  );
};
